import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonos } from '../data/content';
import { SCROLL_TARGET } from '../data/content';
function goToPurchase() {
  document.getElementById(SCROLL_TARGET)?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
}
export function BonusSection() {
  return <section className="bg-sage-deep py-20 sm:py-28" aria-labelledby="bonos-title" data-id="element-14">
      <div className="mx-auto max-w-5xl px-5" data-id="element-15">
        <div className="text-center" data-id="element-16">
          <span className="inline-flex items-center gap-2 rounded-full bg-coral px-4 py-1.5 text-sm font-semibold uppercase tracking-widest text-white" data-id="element-17">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-18" />
            Más los 5 bonos especiales
          </span>
          <h2 id="bonos-title" className="mt-6 font-serif text-3xl font-semibold text-cream sm:text-5xl" data-id="element-19">
            Gratis por el día de hoy
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-cream/80" data-id="element-20">
            Estos bonos son <strong className="text-cream" data-id="element-21">GRATIS</strong> con
            tu compra. Incluidos sin costo adicional solo por hoy.
          </p>
        </div>

        <div className="mt-14 space-y-8" data-id="element-22">
          {bonos.map((bono, i) => <motion.article key={bono.number} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5,
          delay: i % 2 * 0.05
        }} className="grid items-center gap-6 rounded-3xl bg-cream p-6 sm:grid-cols-[220px_1fr] sm:gap-8 sm:p-8" data-id="element-23">
              <button type="button" onClick={goToPurchase} aria-label={`Ver oferta — ${bono.title}`} className="group relative mx-auto block w-44 overflow-hidden rounded-2xl sm:mx-0 sm:w-full" data-id="element-24">
                <span className="absolute right-3 top-3 z-10 rounded-full bg-coral px-3 py-1 text-xs font-bold uppercase tracking-wide text-white shadow" data-id="element-25">
                  Gratis hoy
                </span>
                <img src={bono.image} alt={`Portada del ${bono.number}: ${bono.title}`} className="w-full rounded-2xl shadow-lg transition-transform duration-300 group-hover:scale-[1.03]" loading="lazy" data-id="element-26" />
              </button>

              <div data-id="element-27">
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-coral" data-id="element-28">
                  {bono.number}
                </p>
                <h3 className="mt-2 font-serif text-2xl font-semibold text-ink" data-id="element-29">
                  {bono.title}
                </h3>
                <p className="mt-2 font-serif text-lg italic text-sage-deep" data-id="element-30">
                  {bono.hook}
                </p>
                <p className="mt-3 text-[15px] leading-relaxed text-ink/75" data-id="element-31">
                  {bono.body}
                </p>
                <p className="mt-3 text-[15px] font-semibold leading-relaxed text-ink" data-id="element-32">
                  {bono.closing}
                </p>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}